<template>
    <div class="container-fluid pt-section-fix" id="contacts">
        <div class="row position-relative">
            <div class="col-12 col-md-3 col-xl-2 section-main-title">
                <div class="d-block d-md-inline-block main-background">КОНТАКТИ</div>
            </div>
            <div class="col-12 col-md-9 col-xl-10">
                <div class="row">
                    <div class="col-12 col-lg-6">
                        <div class="info-box passive info-box-medium d-flex mb-3">
                            <div class="info-box-title">
                                <div>
                                    <font-awesome-icon icon="clock" />
                                </div>
                            </div>
                            <div class="info-box-content">
                                <div class="align-items-center d-flex h-100 info-box-head">
                                    работни дни<br>
                                    от 8:30 до 17:00
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div class="info-box passive info-box-medium d-flex mb-3">
                            <div class="info-box-title">
                                <div>
                                    <font-awesome-icon icon="envelope"></font-awesome-icon>
                                </div>
                            </div>
                            <div class="info-box-content">
                                <div class="align-items-center d-flex h-100 info-box-head">
                                    contact@adminplus.bg
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div class="info-box passive info-box-medium d-flex mb-3">
                            <div class="info-box-title">
                                <div>
                                    <font-awesome-icon :icon="['fas', 'phone-alt']"></font-awesome-icon>
                                </div>
                            </div>
                            <div class="info-box-content">
                                <div class="align-items-center d-flex justify-content-between h-100 info-box-head">
                                    <div>
                                        За поддръжка:
                                        <div>
                                            0889 846 651<br>
                                            0876 559 553
                                        </div>
                                    </div>
                                    <div>
                                        За абонамент:
                                        <div>
                                            0878 344 552  
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div class="info-box passive info-box-medium d-flex mb-3">
                            <div class="info-box-title info-box-img-link">
                                <a href="https://www.facebook.com/adminplusbg/"
                                   target="_blank">
                                    <font-awesome-icon :icon="['fab', 'facebook-f']"></font-awesome-icon>
                                </a>
                            </div>
                            <div class="info-box-content">
                                <div class="align-items-center d-flex h-100 info-box-head">
                                    <a href="https://www.facebook.com/adminplusbg/"
                                       target="_blank"
                                       class="info-box-link">АдминПлюс<br>посетете ни!</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div class="info-box passive info-box-medium d-flex mb-3">
                            <div class="info-box-title info-box-img-link">
                                <a href="https://helpdesk.adminplus.bg"
                                   target="_blank">
                                   <support-icon></support-icon>
                                </a>
                            </div>
                            <div class="info-box-content">
                                
                                <div class="align-items-center d-flex h-100 info-box-head">
                                    <a href="https://helpdesk.adminplus.bg"
                                       target="_blank"
                                       class="info-box-link">Система за клиентски запитвания:<br>https://helpdesk.adminplus.bg </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div class="info-box passive info-box-medium d-flex mb-3">
                            <div class="info-box-title info-box-img-link">
                                <a href="https://www.youtube.com/c/%D0%95%D0%BB%D0%B5%D0%BA%D1%82%D1%80%D0%BE%D0%BD%D0%BD%D0%B0%D0%BF%D0%BB%D0%B0%D1%82%D1%84%D0%BE%D1%80%D0%BC%D0%B0%D0%90%D0%B4%D0%BC%D0%B8%D0%BD%D0%9F%D0%BB%D1%8E%D1%81"
                                   target="_blank">
                                    <font-awesome-icon :icon="['fab', 'youtube']"></font-awesome-icon>
                                </a>
                            </div>
                            <div class="info-box-content">
                                <div class="align-items-center d-flex h-100 info-box-head">
                                    <a href="https://www.youtube.com/c/%D0%95%D0%BB%D0%B5%D0%BA%D1%82%D1%80%D0%BE%D0%BD%D0%BD%D0%B0%D0%BF%D0%BB%D0%B0%D1%82%D1%84%D0%BE%D1%80%D0%BC%D0%B0%D0%90%D0%B4%D0%BC%D0%B8%D0%BD%D0%9F%D0%BB%D1%8E%D1%81"
                                       target="_blank"
                                       class="info-box-link">Абонирайте се за YouTube канала на платформата:<br>Електронна платформа АдминПлюс </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import SupportIcon from '@/components/modules-component/icons/support-icon'
    export default {
        name: "contacts-component",
        components: { SupportIcon }
    }
</script>

<style scoped>

</style>
